import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';

import { message } from 'antd';

const model = {
  state: {
    queryParams: {
      cur_page: 1,
      per_page: 10,
    },
    list: [],
    listLoading: false,
    groupQrCodeVisible: false,
    groupQrcodeinfo: {},
    groupDetail: {},
    page: {
      pageNo: 1,
      pageSize: 5,
    },
    customerGroupList: [],
    customerGroupListTotal: 0, // 取餐点列表total
    total: 0, // 饭圈列表total
    groupId: 0,
    canAuditGroupDetail: false,
    nearbyAddrFilter: {
      pageNo: 1,
      pageSize: 10,
    },
    nearbyAddList: [],
    nearbyAddListTotal: 0,
    bdList: [],
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { ChiefCustomerManage, basic }, getState }) => ({
    onSearch(queryParams) {
      if (!queryParams.auditStatus) {
        delete queryParams.auditStatus;
      }
      ChiefCustomerManage.setState({ queryParams });
      ChiefCustomerManage.getList();
    },
    async getList(sortColumnList) {
      const { queryParams } = getState().ChiefCustomerManage;
      const { cur_page, per_page } = getState().ChiefCustomerManage.queryParams;
      ChiefCustomerManage.setState({ listLoading: true });
      const data = await fetch('/saasmerchant/web/customergroup/page', {
        type: 'POST',
        params: filterNull({
          ...queryParams,
          cur_page: undefined,
          per_page: undefined,
          pageNo: cur_page,
          pageSize: per_page,
          withAddress: true,
          sortColumnList,
        }),
        useJson: true,
      });
      if (data) {
        ChiefCustomerManage.setState({ list: data.list, total: data.total, listLoading: false });
      }
    },
    onNav(page) {
      const { queryParams } = getState().ChiefCustomerManage;
      ChiefCustomerManage.setState({ queryParams: { ...queryParams, cur_page: page } });
      ChiefCustomerManage.getList();
    },
    onReset() {
      ChiefCustomerManage.setState({
        queryParams: {
          cur_page: 1,
          per_page: 10,
        },
      });
    },
    setGroupId(groupId) {
      ChiefCustomerManage.setState({ groupId });
    },
    setGroupQrCodeVisible(groupQrCodeVisible) {
      ChiefCustomerManage.setState({ groupQrCodeVisible });
    },
    changeGroupQrCodeVisible(groupQrcodeinfo) {
      ChiefCustomerManage.setState({
        groupId: groupQrcodeinfo.groupId,
        groupQrcodeinfo: { ...groupQrcodeinfo },
      });
    },
    setQueryParams(params) {
      const { queryParams } = getState().ChiefCustomerManage;
      ChiefCustomerManage.setState({ queryParams: { ...queryParams, ...params } });
    },
    // 绑定饭圈二维码
    async bindGroupQrcode(params) {
      const { groupQrcodeinfo } = getState().ChiefCustomerManage;
      const data = await fetch('/saasmerchant/web/customergroup/qrcode/bind', {
        type: 'POST',
        useJson: true,
        params: {
          groupId: groupQrcodeinfo.groupId,
          ...params,
        },
      });
      if (data) {
        message.success('设置成功');
        ChiefCustomerManage.setGroupQrCodeVisible(false);
        ChiefCustomerManage.getList();
      }
      return data;
    },
    // 获取单个饭圈信息
    async getGroupDetail(groupId) {
      const data = await fetch('/saasmerchant/web/customergroup/info', {
        params: {
          groupId,
        },
      });
      if (data) {
        ChiefCustomerManage.setState({ groupDetail: data });
      }
      return data;
    },
    // 审核饭圈详细信息
    async postAuditGroupDetail(params) {
      const data = await fetch('/saasmerchant/web/customergroup/audit', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('审核成功');
      }
      return data;
    },
    // 设置饭圈名称
    async setGroupName(params) {
      const data = await fetch('/saasmerchant/web/customergroup/edit', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('饭圈名称设置成功');
      }
      return data;
    },
    // 更换团长
    async changeMaster(params) {
      const data = await fetch('/saasmerchant/web/customergroup/master/change', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('更换成功');
      }
      return data;
    },
    // 通过手机号搜索团长
    async searchMaster(params) {
      const data = await fetch('/saasmerchant/web/customergroup/master/available/query/mobile', {
        params: {
          ...params,
        },
      });
      return data;
    },
    // 获取取餐点列表
    async getCustomerGroupList(groupId) {
      const { page } = getState().ChiefCustomerManage;
      const data = await fetch('/saasmerchant/web/customergroup/address/page', {
        type: 'POST',
        useJson: true,
        params: {
          groupId: Number(groupId),
          ...page,
        },
      });
      if (data && data.list) {
        ChiefCustomerManage.setState({
          customerGroupList: data.list,
          customerGroupListTotal: data.total,
          canAuditGroupDetail: false,
        });
        // 遍历 审核通过并且启用至少一条才可以点击审核饭圈
        data.list.forEach((item) => {
          if (item.enabled && item.auditStatus === 'PASSED') {
            ChiefCustomerManage.setState({ canAuditGroupDetail: true });
          }
        });
      }
    },
    // 清空列表
    cleanCustomerGroupList() {
      ChiefCustomerManage.setState({ customerGroupList: [] });
    },
    // 审核取餐点 通过
    async auditGroupPassed(params) {
      const { groupId } = getState().ChiefCustomerManage;
      const data = await fetch('/saasmerchant/web/customergroup/address/audit/pass', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('该取餐点审核通过');
        ChiefCustomerManage.getCustomerGroupList(groupId);
      }
    },
    // 审核取餐点 拒绝
    async auditGroupRefused(params) {
      const { groupId } = getState().ChiefCustomerManage;
      const data = await fetch('/saasmerchant/web/customergroup/address/audit/refuse', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data && data.refused) {
        if (!data.groupAutoRefused) {
          message.success('已拒绝该取餐点');
          ChiefCustomerManage.getCustomerGroupList(groupId);
          return true;
        }
        message.success('无可通过饭圈取餐点，饭圈审核不予通过！');
        return 'push';
      }
      message.error('拒绝失败！');
      return false;
    },
    // 启用取餐点
    async UseGroupAddress(addressId) {
      const { groupId } = getState().ChiefCustomerManage;
      const data = await fetch('/saasmerchant/web/customergroup/address/enable', {
        type: 'POST',
        useJson: true,
        params: {
          addressId,
        },
      });
      if (data) {
        message.success('该取餐点已启用');
        ChiefCustomerManage.getCustomerGroupList(groupId);
        ChiefCustomerManage.getGroupDetail(groupId);
      } else {
        message.error('启用失败');
      }
      return data;
    },
    // 停用取餐点
    async StopGroupAddress(params) {
      const { groupId } = getState().ChiefCustomerManage;
      const { addressId, remark } = params;
      const data = await fetch('/saasmerchant/web/customergroup/address/disable', {
        type: 'POST',
        useJson: true,
        params: {
          addressId,
          remark,
        },
      });
      if (data) {
        message.success('该取餐点已停用');
        ChiefCustomerManage.getCustomerGroupList(groupId);
      }
      return data;
    },
    //  编辑取餐点信息
    async editAuditGroupDetail(params) {
      const data = await fetch('/saasmerchant/web/customergroup/address/edit', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('编辑成功');
      }
      return data;
    },
    ChangePage(pageNo) {
      const { groupId } = getState().ChiefCustomerManage;
      const { page } = getState().ChiefCustomerManage;
      ChiefCustomerManage.setState({ page: { ...page, pageNo } });
      ChiefCustomerManage.getCustomerGroupList(groupId);
    },
    resetPage() {
      ChiefCustomerManage.setState({ page: { pageNo: 1, pageSize: 5 } });
    },
    // 停用，启用饭圈
    async changeStatus(status, params) {
      let url = '';
      if (status === 1) {
        url = '/saasmerchant/web/customergroup/enable';
      } else {
        url = '/saasmerchant/web/customergroup/disable';
      }
      const data = await fetch(url, {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success(`${status === 1 ? '启用' : '停用'}成功`);
        ChiefCustomerManage.getList();
      }
      return data;
    },
    setNearbyFilter(params = {}) {
      ChiefCustomerManage.setState({
        nearbyAddrFilter: params,
      });
    },
    // 获取附近取餐点
    async getNearbyAddrList(params) {
      const data = await fetch('/saasmerchant/web/customergroup/address/address/nearby/page', {
        params,
      });
      if (data && data.list) {
        ChiefCustomerManage.setState({
          nearbyAddList: data.list || [],
          nearbyAddListTotal: data.total,
        });
      } else {
        ChiefCustomerManage.setState({
          nearbyAddList: [],
          nearbyAddListTotal: 0,
        });
      }
    },
    // 获取商圈列表
    async getBDList(params) {
      const bdList = await fetch(
        '/saasmerchant/fsarea/businessDistrict/getBusinessDistrictIdByName',
        {
          params,
        },
      );
      ChiefCustomerManage.setState({ bdList: bdList || [] });
      return bdList;
    },
    clearBDList() {
      ChiefCustomerManage.setState({ bdList: [] });
    },
    // 绑定企业微信群
    async bindGroupChat(params) {
      const data = await fetch('/saasmerchant/web/customergroup/bindGroupChat', {
        params,
        type: 'POST',
        useJson: true,
      });
      return data;
    },
    // 获取企业微信同步结果
    async getSyncQyWeChatResult() {
      const data = await fetch('/saasmerchant/web/customergroup/getSyncQyWeChatResult', {});
      return data;
    },
    // 导出饭圈列表
    async exportCustomerList() {
      const { queryParams } = getState().ChiefCustomerManage;
      await fetch('/saasmerchant/web/customergroup/export', {
        type: 'POST',
        params: filterNull({
          ...queryParams,
          cur_page: undefined,
          per_page: undefined,
          withAddress: true,
        }),
        useJson: true,
      });
      basic.setLogListDot(true);
    },
  }),
};

export default model;
